import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/** Query blog entries for curr orchid pro */
export default async function queryBlogEntryByPro(orchidProCognitoSub) {
  const res = await fetchOrchidAPI(
    `/api/blog/v1/blog_entry/submissions/${orchidProCognitoSub}`,
  );
  if (!res.ok) {
    throw new Error(
      `failed to fetch blogs of curr pro: ${getErrorDetail(await res.text())}`,
    );
  }

  return res.json();
}
